export default "__VITE_ASSET__4a69a4bb__"